const visitbrussels1 = require('./visitbrussels_1.jpg');
const visitbrussels2 = require('./visitbrussels_2.jpg');
const visitbrussels3 = require('./visitbrussels_3.jpg');
const visitbrussels4 = require('./visitbrussels_4.jpg');
const visitbrussels5 = require('./visitbrussels_5.jpg');
const visitbrussels6 = require('./visitbrussels_6.jpg');
const visitbrussels7 = require('./visitbrussels_7.jpg');
const spacehologram1 = require('./spacehologram_1.jpg');
const spacehologram2 = require('./spacehologram_2.jpg');
const spacehologram3 = require('./spacehologram_3.jpg');
const tinyworldmk1 = require('./tinyworldmk_1.jpg');
const tinyworldmk2 = require('./tinyworldmk_2.jpg');


module.exports = {
  'visitbrussels_1.jpg': visitbrussels1,
  'visitbrussels_2.jpg': visitbrussels2,
  'visitbrussels_3.jpg': visitbrussels3,
  'visitbrussels_4.jpg': visitbrussels4,
  'visitbrussels_5.jpg': visitbrussels5,
  'visitbrussels_6.jpg': visitbrussels6,
  'visitbrussels_7.jpg': visitbrussels7,
  'spacehologram_1.jpg': spacehologram1,
  'spacehologram_2.jpg': spacehologram2,
  'spacehologram_3.jpg': spacehologram3,
  'tinyworldmk_1.jpg': tinyworldmk1,
  'tinyworldmk_2.jpg': tinyworldmk2,
};
